import styled from '@emotion/styled'
import dynamic from 'next/dynamic'
import { useTheme } from '@emotion/react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import Carousel from './components/Carousel'
import CollectAndProcess from './components/CollectAndProcess'
import Features from './components/Features'
import Plan from './components/Plan'
import Testimonials from './components/Testimonials'

import ogImagePng from './assets/OgImage.png'

const GettingStarted = dynamic(() => import(`@segment/templates/GettingStarted`))

const TwilioEngageView = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Twilio Developer Plan | Twilio Segment"
        pageDescription="Unify your customer data with Twilio Segment and Twilio."
        pageOG={ogImagePng}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <Navigation />
        <Hero />
        <Main>
          <Carousel />
          <CollectAndProcess />
          <Features />
          <Plan />
          <Testimonials />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default TwilioEngageView
